@if (overlay() && visible()) {
  <div class="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full"></div>
}
@if (visible()) {
  <div class="pointer-events-none fixed inset-0 flex items-end px-4 py-6 sm:items-start sm:p-6 z-1001">
    <div class="flex w-full flex-col items-center space-y-4 sm:items-end">
      <div class="pointer-events-auto w-full max-w-sm overflow-hidden rounded-lg bg-white shadow-lg ring-1 ring-black ring-opacity-5">
        <div class="p-4">
          <div class="flex items-start">
            @if (type() === 'error') {
              <div class="flex-shrink-0 text-red-700">
                <vti-icons [icon]="'error'" color="red" colorTint="400" size="5"></vti-icons>
              </div>
              <div class="ml-3 w-0 flex-1 pt-0.5">
                <p class="text-sm font-medium text-gray-900" i18n>Error</p>
                <p class="mt-4 text-sm text-gray-500">{{ message() }}</p>
              </div>
            } @else if (type() === 'warning') {
              <div class="flex-shrink-0">
                <vti-icons [icon]="'error'" color="red" colorTint="400" size="5"></vti-icons>
              </div>
              <div class="ml-3 w-0 flex-1 pt-0.5">
                <p class="text-sm font-medium text-gray-900" i18n>Warning</p>
                <p class="mt-1 text-sm text-gray-500">{{ message() }}</p>
              </div>
            } @else if (type() === 'info') {
              <div class="flex-shrink-0">
                <vti-icons [icon]="'error'" color="red" colorTint="400" size="5"></vti-icons>
              </div>
              <div class="ml-3 w-0 flex-1 pt-0.5">
                <p class="text-sm font-medium text-gray-900" i18n>Information</p>
                <p class="mt-1 text-sm text-gray-500">{{ message() }}</p>
              </div>
            }
            <div class="ml-4 flex flex-shrink-0">
              <button
                type="button"
                class="inline-flex rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-vti-500 focus:ring-offset-2"
                (click)="closeModal()"
              >
                <span class="sr-only">Close</span>
                <svg class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                  <path
                    d="M6.28 5.22a.75.75 0 00-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 101.06 1.06L10 11.06l3.72 3.72a.75.75 0 101.06-1.06L11.06 10l3.72-3.72a.75.75 0 00-1.06-1.06L10 8.94 6.28 5.22z"
                  />
                </svg>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
}
